import React from 'react';
import Chart from "react-google-charts";

const SUBREGION_CODES = {
  "Northern Africa": '015',
  "Western Africa": '011',
  "Middle Africa": '017',
  "Eastern Africa": '014',
  "Southern Africa": '018',
  "Northern Europe": '154',
  "Western Europe": '155',
  "Eastern Europe": '151',
  "Southern Europe": '039',
  "Central Europe": '150', //Europe
  "Southeast Europe": '150', //Europe
  "North America": '021',
  "Caribbean": '029',
  "Central America": '013',
  "South America": '005',
  "Central Asia": '143',
  "Eastern Asia": '030',
  "Southern Asia": '034',
  "South-Eastern Asia": '035',
  "Western Asia": '145',
  "Australia and New Zealand": '053',
  "Melanesia": '054',
  "Micronesia": '057',
  "Polynesia": '061',
};

class Shape extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        options: {
          region: SUBREGION_CODES[this.props.subregion],
          legend: 'none',
          enableRegionInteractivity: false,
          colorAxis: {colors: ['white', '#D5D8B5', '#809A6F']},
          datalessRegionColor: '#D5D8B5',
          backgroundColor: '#BDE6F1',
        },
        data: [    
          ["Country", "Selected"],
          [this.props.country, 1000]
        ],
      };
    }
    
    componentWillReceiveProps(nextProps) {
      if(this.props !== nextProps) {
        this.setState({
          options: {
            region: SUBREGION_CODES[nextProps.subregion],
            legend: 'none',
            enableRegionInteractivity: false,
            colorAxis: {colors: ['white', '#D5D8B5', '#809A6F']},
            datalessRegionColor: '#D5D8B5',
            backgroundColor: '#BDE6F1',
          },
          data: [    
            ["Country", "Selected"],
            [nextProps.country, 1000]
          ],
        });
      }
    }
    

    render() {
        return(    
        <div className="Shape">
            <Chart chartType="GeoChart" width="100%" height="400px" data={this.state.data} options={this.state.options} />
        </div>);
    }
  }
export default Shape;